<p-radioButton
  *ngIf="enableNoParentSelection"
  class="kNoParentOption"
  [value]="null"
  [(ngModel)]="_selectedCategory"
  [ngModelOptions]="{ standalone: true }"
  (click)="_clearSelection()"
  label="{{ 'applications.content.moveCategory.noParent' | translate }}"
></p-radioButton>

<div class="kMain">
  <kAutoComplete
    #autoComplete
    [disabled]="!_categoriesLoaded"
    [multiple]="false"
    field="name"
    suggestionItemField="item"
    suggestionLabelField="name"
    suggestionSelectableField="isSelectable"
    placeholder="{{ 'applications.entries.entryMetadata.searchCategoriesPH' | translate }}"
    [minLength]="3"
    (onSelect)="_onAutoCompleteSelected()"
    [suggestionsProvider]="_categoriesProvider"
    (completeMethod)="_onAutoCompleteSearch($event)"
  >
  </kAutoComplete>
  <k-categories-tree
    #categoriesTree
    [selectionMode]="'single'"
    [(selectedCategory)]="_selectedCategory"
    (onCategoriesLoaded)="_categoriesLoaded = true"
    (onCategorySelected)="_onCategorySelected($event)"
  ></k-categories-tree>
</div>
<div class="kSelectedCategoryTooltip" [kTooltip]="_selectionTooltip">{{ _selectionTooltip }}</div>
